var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('rateios-tabela',{attrs:{"rateios":_vm.rateios,"valorASerRateado":_vm.valorASerRateado,"valorDisponivel":_vm.valorDisponivel}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }